// FILE: src/Components/CreateGroup/CreateBrandWorkflowModal.js (FULLY UPDATED)

import React, { useState, useEffect } from 'react';
import { Modal, message, Input, Button } from 'antd';
import { useDispatch } from 'react-redux';
import { createGroup } from '../../services/user.profile';
import { checkOnboardingStatus } from '../../services/group';
import UpgradeModal from '../BuySubscription/UpgradeModal';
import { fetchGroups } from '../../store/Slices/GroupSlice';
import { AiProcessingScreen } from '../Onboarding'; // Import the loading screen

export default function CreateBrandWorkflowModal({ isOpen, onClose, onBrandCreateComplete }) {
const [view, setView] = useState('form'); // 'form' or 'loading'
const [brandName, setBrandName] = useState('');
const [website, setWebsite] = useState('');
const [isLoading, setIsLoading] = useState(false);
const [pollingGroupId, setPollingGroupId] = useState(null);
const [processingMessage, setProcessingMessage] = useState("Initializing AI Agents...");
const [upgradeModal, setUpgradeModal] = useState({ visible: false, message: '', featureName: '' });
const dispatch = useDispatch();

useEffect(() => {
if (!pollingGroupId || view !== 'loading') {
return;
}

let pollingInterval;
let messageInterval;
let isMounted = true;

const handleJobCompletion = (status) => {
if (!isMounted) return;
if (status === 'completed' || status === 'failed') {
onBrandCreateComplete(brandName);
}
};

const pollStatus = async () => {
try {
const result = await checkOnboardingStatus(pollingGroupId);
if (!isMounted) return;

if (result.status === 'completed' || result.status === 'failed') {
clearInterval(pollingInterval);
clearInterval(messageInterval);
handleJobCompletion(result.status);
}
} catch (error) {
console.error("Polling error in modal:", error);
clearInterval(pollingInterval);
clearInterval(messageInterval);
if (isMounted) {
message.error("Could not check brand status. Please try again from the Brand Kit page.");
onClose(); // Close modal on error
}
}
};

const messages = ["Scanning website...", "Extracting assets...", "Analyzing colors...", "Finalizing DNA..."];
let msgIndex = 0;
messageInterval = setInterval(() => {
if (isMounted) setProcessingMessage(messages[msgIndex++ % messages.length]);
}, 4000);

pollStatus();
pollingInterval = setInterval(pollStatus, 5000);

return () => {
isMounted = false;
clearInterval(pollingInterval);
clearInterval(messageInterval);
};
}, [pollingGroupId, view, brandName, onClose, onBrandCreateComplete]);

const handleCreateBrand = async () => {
if (!brandName.trim() || !website.trim()) {
message.error("Brand Name and Website are required.");
return;
}
if (!website.includes('.')) {
message.error("Please enter a valid website URL.");
return;
}

setIsLoading(true);
try {
const response = await createGroup({
groupName: brandName,
website: website,
});

if (response && response.success && response.group?._id) {
dispatch(fetchGroups());
setPollingGroupId(response.group._id);
setView('loading'); // Switch to loading view
} else {
message.error(response.error || "Failed to create brand.");
}
} catch (error) {
if (error.response?.data?.errorType === 'LIMIT_REACHED') {
setUpgradeModal({
visible: true,
message: error.response.data.message,
featureName: 'Brands',
});
} else {
message.error(error.message || "An error occurred during brand creation.");
}
} finally {
setIsLoading(false);
}
};

const handleCancel = () => {
setBrandName('');
setWebsite('');
setView('form');
setPollingGroupId(null);
onClose();
};

return (
<>
<Modal
title={view === 'form' ? "Create a New Brand" : "Analyzing Your Brand"}
open={isOpen}
onCancel={handleCancel}
footer={
view === 'form' ? [
<Button key="back" onClick={handleCancel}>
Cancel
</Button>,
<Button key="submit" type="primary" loading={isLoading} onClick={handleCreateBrand}>
Create & Analyze
</Button>,
] : null // No footer in loading view
}
closable={view === 'form'} // Prevent closing while loading
maskClosable={view === 'form'} // Prevent closing while loading
centered
>
{view === 'form' ? (
<div className="p-4 space-y-4">
<p className="text-gray-600">Enter your new brand's name and website. The AI will analyze it to automatically build your brand kit.</p>
<div>
<label className="block text-sm font-medium text-gray-700 mb-1">Brand Name</label>
<Input
placeholder="e.g., Oolook"
value={brandName}
onChange={(e) => setBrandName(e.target.value)}
/>
</div>
<div>
<label className="block text-sm font-medium text-gray-700 mb-1">Brand Website</label>
<Input
placeholder="e.g., https://oolook.in"
value={website}
onChange={(e) => setWebsite(e.target.value)}
/>
</div>
</div>
) : (
<div className="py-8">
<AiProcessingScreen statusText={processingMessage} />
</div>
)}
</Modal>

<UpgradeModal
isOpen={upgradeModal.visible}
onClose={() => setUpgradeModal({ visible: false, message: '', featureName: '' })}
message={upgradeModal.message}
featureName={upgradeModal.featureName}
/>
</>
);
}